import { render } from "./PrayerSubmitted.vue?vue&type=template&id=3c050332&scoped=true"
const script = {}

import "./PrayerSubmitted.vue?vue&type=style&index=0&id=3c050332&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c050332"]])

export default __exports__